import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import Button from "../../../../components/buttons/Buttons";
import styles from "./groupDealerListComponent.module.scss";
import GroupSelectComponent from "./groupSelectComponent/GroupSelectComponent";
import i18next from "i18next";
import { getGroupDropdownOptions } from "../../../../services/APIService";
import _ from "lodash";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import PropTypes from "prop-types";

const GroupDealerListComponent = (props) => {
  const {
    setGroupListTable,
    selectedGroup,
    setSelectedGroup,
    setSelectedGroupId,
  } = props;
  const { setApiErrorModalState } = useApiErrorModalContext();
  const [groupList, setGroupList] = useState([]);

  useEffect(() => {
    getGroupDropdownOptions()
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setGroupList(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [isClick, setIsClick] = useState(false);
  const [open, setOpen] = useState(true);

  return (
    <Box
      className={styles.groupListMainWrapper}
      data-testid="GroupDealerListComponent"
    >
      <Button
        title="Back"
        iconStyle={styles.Back}
        buttonType="muibtn-secondary-with-icon"
        attriType={"button"}
        withIcon={true}
        handleClick={() => setGroupListTable(false)}
      />
      <Box className={styles.groupListWrapper}>
        <Box className={styles.groupLabel}>{i18next.t("Groups")}</Box>
        <Box className={styles.groupListSelectWrapper}>
          <Box className={styles.groupNameListWrapper}>
            <Box className={styles.groupNameWrapper}>
              {_.get(selectedGroup, "group_Name", "-")}
            </Box>
            <Box
              className={styles.downIcon}
              onClick={() => {
                setIsClick(!isClick);
                setOpen(true);
              }}
            ></Box>
          </Box>
          {isClick ? (
            <GroupSelectComponent
              GroupList={groupList}
              open={open}
              setOpen={setOpen}
              setClicked={setIsClick}
              setSelectedGroup={setSelectedGroup}
              setSelectedGroupId={setSelectedGroupId}
            />
          ) : null}
          <Box className={styles.subTextWrapper}>
            <span className={styles.header}>{`${i18next.t(
              "Headquarters"
            )}:`}</span>
            <span className={styles.subText}>
              {!_.isEmpty(_.get(selectedGroup, "group_City", "-"))
                ? _.get(selectedGroup, "group_City", "-")
                : "-"}
            </span>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default GroupDealerListComponent;
GroupDealerListComponent.propTypes= {
  setGroupListTable: PropTypes.any,
  selectedGroup: PropTypes.any,
  setSelectedGroup: PropTypes.any,
  setSelectedGroupId: PropTypes.any,
};
